import React from "react";

function getDateLabel(ts) {
  const d = new Date(ts);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);

  if (d.toDateString() === today.toDateString()) return "Today";
  if (d.toDateString() === yesterday.toDateString()) return "Yesterday";

  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export default function TradebookTable({ trades }) {
  let lastDateLabel = null;

  return (
    <>
      {/* ================= MOBILE VIEW ================= */}
      <div className="sm:hidden space-y-2 max-w-full overflow-hidden">

        {trades.map((trade) => {
          const label = getDateLabel(trade.ts);
          const showHeader = label !== lastDateLabel;
          lastDateLabel = label;

          return (
            <React.Fragment key={trade.trade_id}>
              {showHeader && (
                <div className="text-[11px] font-semibold text-muted-foreground px-1">
                  {label}
                </div>
              )}

              <div className="rounded-lg border border-border bg-card/60 backdrop-blur px-3 py-2 max-w-full overflow-hidden">

                {/* Row 1: Symbol + Side */}
                <div className="flex items-center justify-between gap-2">
                  <div
                    className="text-sm font-medium truncate"
                    title={trade.tradingsymbol}
                  >
                    {trade.tradingsymbol}
                  </div>

                  <span
                    className={`px-2 py-[2px] rounded-full text-[11px] font-semibold ${
                      trade.side === "BUY"
                        ? "bg-emerald-500/20 text-emerald-400"
                        : "bg-red-500/20 text-red-400"
                    }`}
                  >
                    {trade.side}
                  </span>
                </div>

                {/* Row 2: Compact meta row */}
                <div className="mt-1 grid grid-cols-[auto_auto_1fr] items-center gap-x-3 text-[11px] text-muted-foreground">
  <span>
    Qty <b className="text-foreground font-medium">{trade.qty}</b>
  </span>

  <span>
    ₹<b className="text-foreground font-medium">{trade.price}</b>
  </span>

  <span className="text-right tabular-nums">
    {trade.iso_date
      ? trade.iso_date.slice(11, 16)
      : "--"}
  </span>
</div>

              </div>
            </React.Fragment>
          );
        })}
      </div>

      {/* ================= DESKTOP VIEW ================= */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-muted-foreground border-b border-border">
              <th className="py-3 px-4 text-left">Instrument</th>
              <th className="py-3 px-4 text-center">Side</th>
              <th className="py-3 px-4 text-right">Qty</th>
              <th className="py-3 px-4 text-right">Price</th>
              <th className="py-3 px-4 text-right">Time</th>
            </tr>
          </thead>

          <tbody>
            {trades.map((trade) => {
              const label = getDateLabel(trade.ts);
              const showHeader = label !== lastDateLabel;
              lastDateLabel = label;

              return (
                <React.Fragment key={trade.trade_id}>
                  {showHeader && (
                    <tr>
                      <td
                        colSpan={5}
                        className="py-2 px-4 text-xs font-semibold text-muted-foreground"
                      >
                        {label}
                      </td>
                    </tr>
                  )}

                  <tr className="border-b border-border/50">
                    <td
                      className="py-3 px-4 max-w-[180px] truncate text-xs"
                      title={trade.tradingsymbol}
                    >
                      {trade.tradingsymbol}
                    </td>

                    <td className="py-3 px-4 text-center">
                      <span
                        className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                          trade.side === "BUY"
                            ? "bg-emerald-500/20 text-emerald-400"
                            : "bg-red-500/20 text-red-400"
                        }`}
                      >
                        {trade.side}
                      </span>
                    </td>

                    <td className="py-3 px-4 text-right">
                      {trade.qty}
                    </td>

                    <td className="py-3 px-4 text-right">
                      ₹{trade.price}
                    </td>

                    <td className="py-3 px-4 text-right text-xs text-muted-foreground">
                      {trade.iso_date
                        ? trade.iso_date.slice(11, 19)
                        : "--"}
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
